import actionTypes from './actionTypes';
import api, { createAuthenticatedApiInstance } from 'src/utils/api';
import * as log from 'loglevel';
import { setAlert } from 'src/typescript/components/alert/actions';

export const fetchProfile = () => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PROFILE });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const api = createAuthenticatedApiInstance(getState); // to make authenticated requests on server
      const response = await api.get(`private/users/${currentUser.userId}/profile`);
      dispatch({
        type: actionTypes.FETCH_PROFILE_SUCCESS,
        data: response.data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_PROFILE_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateBasics = (basicData) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_PROFILE_BASICS });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await api.put(`private/users/${currentUser.userId}/profile/basics`, {
        'basic-data': basicData,
      });
      dispatch({
        type: actionTypes.UPDATE_PROFILE_BASICS_SUCCESS,
        data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.UPDATE_PROFILE_BASICS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateNotificationPreference = (notificationType, enabled) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;

      // Note: we have to call the api with the specific userNotificationPreferenceId
      // to be able to update the preferences so we need to fetch them first
      // TODO: update the api to accept the notificationType or notificationId
      const response = await api.auroraGet('user-notification-preference', {
        params: { userId: currentUser.userId },
      });

      const {
        data: {
          payload: {
            userNotificationPreference: { notificationPreference: currentPreferences },
          },
        },
      } = response;

      const currentPreference = currentPreferences.find(x => x.notificationType === notificationType);
      if (!currentPreference) return;

      const updatedPreference = { ...currentPreference, enabled };
      await api.auroraPut('user-notification-preference', {
        userId: currentUser.userId,
        notificationPreference: [updatedPreference],
      });

      return dispatch({
        type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE_SUCCESS,
      });
    } catch (ex) {
      log.error(ex);
      return dispatch({ type: actionTypes.UPDATE_NOTIFICATION_PREFERENCE_FAILURE, error: ex });
    }
  };
};
